import { v4 as uuidv4 } from 'uuid';

export function MapperUtils() {
    return {
        getMappedOrderData({ orders, salesChannel, workspaceId }) {
            return orders.map(order => {
                const content = order?.content;
                return {
                    _id: null,
                    id: uuidv4(),
                    channelOrderDate: content?.order?.orderDate,
                    prodName: content?.productOrder?.productName || '',
                    optionName: content?.productOrder?.productOption || '',
                    unit: content?.productOrder?.quantity || 0,
                    receiver: content?.productOrder?.shippingAddress?.name || '',
                    receiverContact1: content?.productOrder?.shippingAddress?.tel1 || '',
                    receiverContact2: content?.productOrder?.shippingAddress?.tel2 || '',
                    destination: content?.productOrder?.shippingAddress?.baseAddress || '',
                    destinationDetail: content?.productOrder?.shippingAddress?.detailedAddress || '',
                    salesChannel: salesChannel || '',
                    orderNumber1: content?.productOrder?.productOrderId,
                    orderNumber2: content?.order?.orderId || '',
                    channelProdCode: content?.productOrder?.productId || '',
                    channelOptionCode: content?.productOrder?.optionCode || '',
                    zipCode: content?.productOrder?.shippingAddress?.zipCode || '',
                    courier: '',
                    transportType: '택배,등기,소포',
                    deliveryMessage: content?.productOrder?.shippingMemo || '',
                    waybillNumber: '',
                    price: content?.productOrder?.expectedSettlementAmount || 0,
                    deliveryCharge: content?.productOrder?.deliveryFeeAmount || 0,
                    barcode: '',
                    prodCode: content?.productOrder?.productId || '',
                    optionCode: content?.productOrder?.optionManageCode || '',
                    releaseOptionCode: content?.productOrder?.optionManageCode || '',
                    managementMemo1: content?.order?.ordererName || '',
                    managementMemo2: content?.order?.ordererTel || '',
                    managementMemo3: content?.productOrder?.packageNumber || '',
                    managementMemo4: '',
                    managementMemo5: '',
                    managementMemo6: salesChannel || '',
                    managementMemo7: '',
                    managementMemo8: content?.productOrder?.totalPaymentAmount || '',
                    managementMemo9: content?.productOrder?.deliveryFeeAmount || '',
                    managementMemo10: '',
                    workspaceId: workspaceId
                }
            })
        }
    }
}

// Compare this snippet from src/views/smartstore/root/wegets/weget-collected-table/weget-collected-table.js:
// channelOrderDate	order.orderDate (판매채널 주문일시)
// prodName	productOrder.productName (상품명 (필수))
// optionName	productOrder.productOption (옵션정보 (필수))
// unit	productOrder.quantity (수량(필수))
// receiver	productOrder.shippingAddress.name (수취인명(필수))
// receiverContact1	productOrder.shippingAddress.tel1 (전화번호1(필수))
// receiverContact2	빈값 (전화번호2)
// destination	productOrder.shippingAddress.baseAddress (주소(필수))
// destinationDetail	productOrder.shippingAddress.detailedAddress (주소 상세)
// salesChannel	스토어명 (판매채널)
// orderNumber1	productOrder.productOrderId (주문번호1)
// orderNumber2	order.orderId (주문번호2)
// channelProdCode	productOrder.productId (상품코드)
// channelOptionCode	productOrder.optionCode (옵션코드)
// zipCode	productOrder.shippingAddress.zipCode (우편번호)
// courier	빈값 (택배사)
// transportType	택배,등기,소포 (배송방식)
// deliveryMessage	productOrder.shippingMemo (배송메세지)
// waybillNumber	빈값 (운송장번호)
// price	productOrder.expectedSettlementAmount (판매금액)
// deliveryCharge	productOrder.deliveryFeeAmount (배송비)
// barcode	빈값 (바코드)
// prodCode	productOrder.productId ([M] 상품코드)   
// optionCode	productOrder.optionManageCode ([M] 옵션코드)
// releaseOptionCode	productOrder.optionManageCode ([M] 출고옵션코드)
// managementMemo1	order.ordererName (구매자명)
// managementMemo2	order.ordererTel (구매자 연락처)
// managementMemo3	productOrder.packageNumber (판매채널 묶음배송번호)
// managementMemo4	빈값 (기타코드)
// managementMemo5	빈값 (관리메모5)
// managementMemo6	스토어명
// managementMemo7	빈값 (CS)
// managementMemo8	(채널 판매매출금액)
// managementMemo9	(채널 배송비)
// managementMemo10	빈값 (관리메모10)